import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDesktopComponent } from "./med-icon-desktop.component";

@NgModule({
  declarations: [
    MedIconDesktopComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDesktopComponent,
  ],
})
export class MedIconDesktopModule { }
